import React, {  useState, useEffect } from 'react';
import {
  CardTitle,
  Card,
  CardContent,
  Textarea,
  Button,
} from '../../../Components';
import { AlunoModel, ProfessorModel } from '../../../Store';
import styled from 'styled-components';

interface IInserirMonografiaModalProps {
  professor: ProfessorModel,
  onInserirMonografia: (alunoId: number, professorId: number, titulo: string) => any,
  alunosAtivos: AlunoModel[]
}

const StyledButton = styled(Button) <any>`
  margin-left: 16px
`;

const StyledTextarea = styled(Textarea) <any>`
  margin: 0;
  grid-column: ${p => p.gridColumn};
`

const Div = styled.div`
  display: flex;
`

const P = styled.p`
  margin: 0 1em 0 1em;
`

const P2 = styled.p`
  margin: 1em;
`

const P3 = styled.p`
  margin: 1em;
  color: red;
`

export default function InserirMonografiaModal(props: IInserirMonografiaModalProps) {
  const { professor, onInserirMonografia } = props;
  const [confirmar, setConfirmar] = useState(false);
  const [titulo, setTitulo] = useState('');
  const [aluno, setAluno] = useState<AlunoModel>();
  const [matricula, setMatricula] = useState('');
  const { alunosAtivos } = props;
  const [matriculaInvalida, setMatriculaInvalida] = useState(false);


  useEffect(() => {
    let alunoMatricula = alunosAtivos.find(a =>
       a.matricula === matricula
    )

    setAluno(alunoMatricula)
  },[matricula])

  function onTituloChange(e: { target: { value: React.SetStateAction<string>; }; }){
    setTitulo(e.target.value)
  }

  function onMatriculaChange(e: { target: { value: React.SetStateAction<string>; }; }){
    setMatricula(e.target.value)
  }

  return (
    <>
      {professor && 
        <Card>         
          <CardTitle>Atribuir uma monografia</CardTitle>
          <CardContent>
          <Div>
            <P>Digite a matrícula do orientando: </P>
            <StyledTextarea
              name='matricula'
              value={matricula}
              maxLength={6}
              onChange={onMatriculaChange}
              gridColumn='3/8'
            >
            </StyledTextarea>
            <StyledTextarea
              name='orientando'
              value={(aluno !== undefined && aluno !== null) ? aluno.nome : 'não encontrado'}
              disabled={true}
              gridColumn='1/4'
            >
            </StyledTextarea>
            </Div>
            <Div>
            <P2>Insira o título da monografia: </P2>
            <StyledTextarea
              name='titulo'
              value={titulo}
              maxLength={255}
              onChange={onTituloChange}
              gridColumn='1/8'
            ></StyledTextarea>
            </Div>
            {!confirmar &&
              <StyledButton
                onClick={() => {
                  if(aluno !== undefined && aluno !== null){
                    setConfirmar(true)
                  }else{
                    setMatriculaInvalida(true)
                  }
                }}>
                Criar
              </StyledButton>
            }
            {!aluno && matriculaInvalida && <P3>Insira uma matrícula válida</P3>}
            {confirmar && 
              <StyledButton
                onClick={() => 
                  {
                    if(aluno !== undefined && aluno !== null){
                      onInserirMonografia(aluno.id,professor.id,titulo)
                      setMatriculaInvalida(false)
                    }
                }}>
                Confirmar
            </StyledButton>
            }
          </CardContent>
        </Card>
      }
    </>
  );
}
